export const conversionFactors = {
  in: 1,
  cm: 2.54,
  mm: 25.4,
  px: 96,
};

export enum SizeUnits {
  INCHES = 'in',
  CENTIMETERS = 'cm',
  MILLIMETERS = 'mm',
  PIXELS = 'px',
}
